module.exports = __webpack_public_path__ + "static/img/利害關係人溝通02TW.85baa7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/利害關係人溝通02TW.jpg
// module id = zR3/
// module chunks = 1